import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, EmployeeInvitesResponseData } from "schema"

type InvitationsResponse = DataResponse<EmployeeInvitesResponseData>

export const getInvitationsQueryKey = () => ["invitations"] as const

export const invitationsQuery = () =>
  queryOptions({
    queryKey: getInvitationsQueryKey(),
    queryFn: async () => {
      const { data } = await axios.get<InvitationsResponse>("/employees/invitations")
      return data.data
    },
  })
